import React from "react"

import {
	Grid,
	Typography,
} from "@mui/material"
import { ThemeProvider } from "@mui/material/styles"

import { darkTheme } from "commons/themes"

interface PageSectionTitleProps extends Readonly<{ children?: React.ReactNode }>
{
	title: string
	color: string
	variant: "page"|"dashboard"
}
interface PageSectionTitleState
{
}
export class PageSectionTitle extends React.Component<PageSectionTitleProps, PageSectionTitleState>
{
	static defaultProps = {
		color: "primary.main",
		variant: "page",
	}

	constructor(props: PageSectionTitleProps)
	{
		super(props)
		this.state = {}
	}

	render()
	{
		let fontSize = undefined
		let fontWeight = "600"
		let paddingX = 4
		if(this.props.variant === "dashboard") {
			fontSize = "16px"
			fontWeight = "normal"
			paddingX = 3
		}

		return (
			<>
				<ThemeProvider theme={darkTheme}>
					<Grid container sx={{backgroundColor: this.props.color, py: 2, px: paddingX}} alignItems="center">
						<Grid item xs>
							<Typography variant="h6"
								sx={{
									color: "primary.contrastText",
									fontWeight: fontWeight,
									fontSize: fontSize,
									lineHeight: "unset",
								}}>
								{this.props.title}
							</Typography>
						</Grid>
						<Grid item xs="auto">
							{this.props.children}
						</Grid>
					</Grid>
				</ThemeProvider>
			</>
		)
	}
}
